var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parent",staticStyle:{"overflow":"hidden"},style:({ height: (_vm.height || 160) + 'px' })},[(_vm.showLoading)?_c('div',[_vm._v(_vm._s(_vm.$t('loading')))]):_vm._e(),_c('VueC3',{staticStyle:{"margin-right":"-50px"},attrs:{"handler":_vm.handler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }